export const AngelWings = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 200 60" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="wingGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor={color} stopOpacity="0.4" />
        <stop offset="100%" stopColor={color} stopOpacity="0.05" />
      </linearGradient>
    </defs>
    <path
      d="M100 30 Q70 5 25 12 Q40 25 25 45 Q70 52 100 30 Z"
      fill="url(#wingGrad)"
      stroke={color}
      strokeWidth="0.6"
    />
    <path
      d="M100 30 Q130 5 175 12 Q160 25 175 45 Q130 52 100 30 Z"
      fill="url(#wingGrad)"
      stroke={color}
      strokeWidth="0.6"
    />
    <circle cx="100" cy="30" r="2.5" fill={color} />
    <circle cx="100" cy="30" r="5" fill="none" stroke={color} strokeWidth="0.5" opacity="0.5" />
  </svg>
);

export const GoldDivider = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 200 20" className={className} aria-hidden="true">
    <line x1="15" y1="10" x2="75" y2="10" stroke={color} strokeWidth="0.6" />
    <line x1="125" y1="10" x2="185" y2="10" stroke={color} strokeWidth="0.6" />
    <path
      d="M85 10 Q100 3 115 10 Q100 17 85 10 Z"
      fill={color}
      opacity="0.8"
    />
    <circle cx="100" cy="10" r="1.5" fill={color} />
    <circle cx="80" cy="10" r="1" fill={color} opacity="0.6" />
    <circle cx="120" cy="10" r="1" fill={color} opacity="0.6" />
  </svg>
);

export const OrnateCorner = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path
      d="M5 95 Q5 60 25 40 Q45 20 95 5"
      fill="none"
      stroke={color}
      strokeWidth="0.8"
      opacity="0.5"
    />
    <path
      d="M15 85 Q15 60 30 45 Q45 30 85 15"
      fill="none"
      stroke={color}
      strokeWidth="0.5"
      opacity="0.3"
    />
    <circle cx="25" cy="40" r="2" fill={color} opacity="0.6" />
    <circle cx="45" cy="20" r="1.5" fill={color} opacity="0.5" />
    <path
      d="M25 40 Q35 30 45 20 M25 40 Q30 50 35 60"
      fill="none"
      stroke={color}
      strokeWidth="0.4"
      opacity="0.4"
    />
  </svg>
);

export const CrossIcon = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 40 60" className={className} aria-hidden="true">
    <line x1="20" y1="5" x2="20" y2="55" stroke={color} strokeWidth="1" />
    <line x1="8" y1="22" x2="32" y2="22" stroke={color} strokeWidth="1" />
    <circle cx="20" cy="22" r="3" fill={color} opacity="0.3" />
    <circle cx="20" cy="5" r="2" fill={color} />
    <circle cx="20" cy="55" r="1.5" fill={color} opacity="0.6" />
  </svg>
);

export const Dove = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 80 60" className={className} aria-hidden="true">
    <path
      d="M40 30 Q25 15 10 20 Q20 28 15 38 Q30 40 40 30 Z"
      fill={color}
      opacity="0.35"
    />
    <path
      d="M40 30 Q55 15 70 20 Q60 28 65 38 Q50 40 40 30 Z"
      fill={color}
      opacity="0.35"
    />
    <ellipse cx="40" cy="30" rx="6" ry="4" fill={color} opacity="0.6" />
    <circle cx="40" cy="26" r="3" fill={color} />
    <path d="M37 24 L32 22 L37 26 Z" fill={color} />
    <circle cx="41" cy="25" r="0.7" fill="#fff" />
  </svg>
);

export const RosetteDivider = ({ color = '#c8a961', className = '' }) => (
  <svg viewBox="0 0 240 30" className={className} aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => (
      <g key={i} transform={`translate(${40 + i * 40}, 15)`}>
        <circle r="6" fill="none" stroke={color} strokeWidth="0.5" opacity="0.5" />
        <circle r="2" fill={color} opacity="0.6" />
        {[0, 45, 90, 135].map((a) => (
          <line
            key={a}
            x1={-6 * Math.cos((a * Math.PI) / 180)}
            y1={-6 * Math.sin((a * Math.PI) / 180)}
            x2={6 * Math.cos((a * Math.PI) / 180)}
            y2={6 * Math.sin((a * Math.PI) / 180)}
            stroke={color}
            strokeWidth="0.3"
            opacity="0.4"
          />
        ))}
      </g>
    ))}
  </svg>
);

export const Stars = ({ color = '#93c5fd', className = '' }) => (
  <svg viewBox="0 0 200 60" className={className} aria-hidden="true">
    {[...Array(8)].map((_, i) => (
      <text
        key={i}
        x={15 + i * 25}
        y={30 + (i % 2 ? 8 : -8)}
        fontSize="14"
        fill={color}
        opacity={0.6}
      >
        ✦
      </text>
    ))}
  </svg>
);

export const FloralCorner = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 120 120" className={className} aria-hidden="true">
    <path
      d="M10 110 Q10 60 40 40 Q70 20 110 10"
      fill="none"
      stroke={color}
      strokeWidth="1.2"
      opacity="0.5"
    />
    <circle cx="40" cy="40" r="3" fill={color} opacity="0.7" />
    <circle cx="70" cy="25" r="2" fill={color} opacity="0.7" />
    <path
      d="M40 40 Q55 30 70 25 M40 40 Q50 55 55 70"
      fill="none"
      stroke={color}
      strokeWidth="0.8"
      opacity="0.4"
    />
    {/* Hojas adicionales para más detalle */}
    <path
      d="M50 60 Q60 55 65 65 Q55 70 50 60 Z"
      fill={color}
      opacity="0.15"
    />
    <path
      d="M60 30 Q70 25 75 35 Q65 40 60 30 Z"
      fill={color}
      opacity="0.15"
    />
  </svg>
);


export const WeddingRings = ({ color = '#b8935a', className = '' }) => (
  <svg viewBox="0 0 80 50" className={className} aria-hidden="true">
    <circle cx="30" cy="30" r="14" fill="none" stroke={color} strokeWidth="1.5" />
    <circle cx="50" cy="30" r="14" fill="none" stroke={color} strokeWidth="1.5" />
    <path d="M30 16 L26 10 L34 10 Z" fill={color} opacity="0.6" />
    <circle cx="30" cy="9" r="2" fill={color} />
    <path d="M40 30 Q40 25 45 25" fill="none" stroke={color} strokeWidth="0.8" opacity="0.5" />
  </svg>
);

export const Laurel = ({ color = '#b8935a', className = '' }) => (
  <svg viewBox="0 0 120 60" className={className} aria-hidden="true">
    <path
      d="M60 55 Q35 50 20 35 Q10 22 15 10"
      fill="none" stroke={color} strokeWidth="1"
    />
    <path
      d="M60 55 Q85 50 100 35 Q110 22 105 10"
      fill="none" stroke={color} strokeWidth="1"
    />
    {[15, 25, 35, 45].map((x, i) => (
      <g key={i}>
        <ellipse cx={x + 10} cy={20 + i * 6} rx="5" ry="3"
          transform={`rotate(-30 ${x + 10} ${20 + i * 6})`}
          fill={color} opacity="0.35" />
        <ellipse cx={110 - x - 10 + 100} cy={20 + i * 6} rx="5" ry="3"
          transform={`rotate(30 ${110 - x - 10 + 100} ${20 + i * 6})`}
          fill={color} opacity="0.35" />
      </g>
    ))}
    <circle cx="60" cy="55" r="2.5" fill={color} />
  </svg>
);


// ============================================================
// ART DÉCO
// ============================================================

export const ArtDecoFrame = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 200 200" className={className} aria-hidden="true" preserveAspectRatio="none">
    {/* Esquinas geométricas */}
    <path d="M0 0 L60 0 L0 60 Z" fill={color} opacity="0.08" />
    <path d="M0 0 L40 0 M0 0 L0 40 M0 20 L20 0" stroke={color} strokeWidth="0.8" opacity="0.5" fill="none" />
  </svg>
);

export const SunburstDivider = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 240 40" className={className} aria-hidden="true">
    {/* Líneas simétricas radiales */}
    {[...Array(11)].map((_, i) => {
      const angle = -45 + i * 9;
      const rad = (angle * Math.PI) / 180;
      const x2 = 120 + Math.sin(rad) * 60;
      const y2 = 20 - Math.cos(rad) * 18;
      return (
        <line
          key={i}
          x1="120"
          y1="20"
          x2={x2}
          y2={y2}
          stroke={color}
          strokeWidth="0.6"
          opacity={i % 2 ? 0.4 : 0.7}
        />
      );
    })}
    <circle cx="120" cy="20" r="3" fill={color} />
    <circle cx="120" cy="20" r="6" fill="none" stroke={color} strokeWidth="0.6" opacity="0.5" />
  </svg>
);

export const DecoFrameTop = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 400 60" className={className} aria-hidden="true" preserveAspectRatio="none">
    <path d="M0 30 L200 0 L400 30 L400 32 L200 2 L0 32 Z" fill={color} opacity="0.7" />
    <path d="M0 40 L200 15 L400 40" stroke={color} strokeWidth="0.6" fill="none" opacity="0.5" />
    <path d="M0 48 L200 25 L400 48" stroke={color} strokeWidth="0.4" fill="none" opacity="0.3" />
  </svg>
);

export const DecoFrameBottom = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 400 60" className={className} aria-hidden="true" preserveAspectRatio="none">
    <path d="M0 30 L200 60 L400 30 L400 28 L200 58 L0 28 Z" fill={color} opacity="0.7" />
    <path d="M0 20 L200 45 L400 20" stroke={color} strokeWidth="0.6" fill="none" opacity="0.5" />
  </svg>
);

export const DecoMonogram = ({ color = '#d4af37', className = '', initials = 'M & C' }) => (
  <svg viewBox="0 0 160 160" className={className} aria-hidden="true">
    {/* Aro exterior */}
    <circle cx="80" cy="80" r="72" fill="none" stroke={color} strokeWidth="0.6" opacity="0.5" />
    <circle cx="80" cy="80" r="66" fill="none" stroke={color} strokeWidth="0.4" opacity="0.3" />
    {/* Rayos */}
    {[...Array(32)].map((_, i) => {
      const angle = (i * 360) / 32;
      const rad = (angle * Math.PI) / 180;
      const x1 = 80 + Math.cos(rad) * 72;
      const y1 = 80 + Math.sin(rad) * 72;
      const x2 = 80 + Math.cos(rad) * 62;
      const y2 = 80 + Math.sin(rad) * 62;
      return (
        <line
          key={i}
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={color}
          strokeWidth={i % 4 === 0 ? 1 : 0.4}
          opacity={i % 4 === 0 ? 0.7 : 0.3}
        />
      );
    })}
    {/* Iniciales */}
    <text
      x="80"
      y="92"
      textAnchor="middle"
      fontFamily="'Cinzel', serif"
      fontSize="34"
      fontWeight="600"
      fill={color}
      letterSpacing="2"
    >
      {initials}
    </text>
  </svg>
);

export const DecoDividerSmall = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 120 20" className={className} aria-hidden="true">
    <line x1="0" y1="10" x2="45" y2="10" stroke={color} strokeWidth="0.6" />
    <line x1="75" y1="10" x2="120" y2="10" stroke={color} strokeWidth="0.6" />
    <path d="M60 4 L66 10 L60 16 L54 10 Z" fill={color} opacity="0.8" />
    <circle cx="48" cy="10" r="1.5" fill={color} opacity="0.7" />
    <circle cx="72" cy="10" r="1.5" fill={color} opacity="0.7" />
  </svg>
);

export const DecoScallop = ({ color = '#d4af37', className = '' }) => (
  <svg viewBox="0 0 400 40" className={className} aria-hidden="true" preserveAspectRatio="none">
    {[...Array(20)].map((_, i) => {
      const x = i * 20;
      return (
        <path
          key={i}
          d={`M${x} 40 Q${x + 10} 10 ${x + 20} 40`}
          fill="none"
          stroke={color}
          strokeWidth="0.6"
          opacity="0.5"
        />
      );
    })}
  </svg>
);


// ============================================================
// BOHO
// ============================================================

export const PampasGrass = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 80 200" className={className} aria-hidden="true">
    {/* Tallo principal */}
    <path d="M40 200 Q40 120 38 60" stroke={color} strokeWidth="1" fill="none" opacity="0.5" />
    {/* Ramas de pampas (plumas) */}
    <ellipse cx="38" cy="55" rx="10" ry="30" fill={color} opacity="0.35" />
    <ellipse cx="38" cy="55" rx="6" ry="25" fill={color} opacity="0.5" />
    <ellipse cx="38" cy="55" rx="3" ry="20" fill={color} opacity="0.7" />
    {/* Hojas secundarias */}
    <path d="M40 130 Q30 110 25 90" stroke={color} strokeWidth="0.8" fill="none" opacity="0.5" />
    <path d="M40 150 Q52 130 58 110" stroke={color} strokeWidth="0.8" fill="none" opacity="0.5" />
    <path d="M40 170 Q30 155 22 140" stroke={color} strokeWidth="0.8" fill="none" opacity="0.4" />
    {/* Ramitas pequeñas */}
    <circle cx="25" cy="90" r="2" fill={color} opacity="0.4" />
    <circle cx="58" cy="110" r="2" fill={color} opacity="0.4" />
  </svg>
);

export const ArchFrame = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 300 500" className={className} aria-hidden="true" preserveAspectRatio="none">
    {/* Arco exterior */}
    <path
      d="M20 480 L20 150 Q20 20 150 20 Q280 20 280 150 L280 480"
      fill="none"
      stroke={color}
      strokeWidth="1.2"
      opacity="0.5"
    />
    {/* Arco interior */}
    <path
      d="M35 480 L35 155 Q35 35 150 35 Q265 35 265 155 L265 480"
      fill="none"
      stroke={color}
      strokeWidth="0.6"
      opacity="0.3"
    />
    {/* Base decorativa */}
    <line x1="20" y1="480" x2="60" y2="480" stroke={color} strokeWidth="1.2" opacity="0.5" />
    <line x1="240" y1="480" x2="280" y2="480" stroke={color} strokeWidth="1.2" opacity="0.5" />
  </svg>
);

export const SunMoon = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 120 80" className={className} aria-hidden="true">
    {/* Sol a la izquierda */}
    <circle cx="35" cy="40" r="12" fill="none" stroke={color} strokeWidth="1" />
    <circle cx="35" cy="40" r="6" fill={color} opacity="0.5" />
    {[...Array(8)].map((_, i) => {
      const angle = (i * 360) / 8;
      const rad = (angle * Math.PI) / 180;
      return (
        <line
          key={i}
          x1={35 + Math.cos(rad) * 15}
          y1={40 + Math.sin(rad) * 15}
          x2={35 + Math.cos(rad) * 20}
          y2={40 + Math.sin(rad) * 20}
          stroke={color}
          strokeWidth="0.8"
          opacity="0.6"
        />
      );
    })}

    {/* Luna a la derecha */}
    <path
      d="M100 25 A 15 15 0 1 0 100 55 A 12 12 0 1 1 100 25 Z"
      fill={color}
      opacity="0.5"
    />

    {/* Línea central */}
    <line x1="55" y1="40" x2="65" y2="40" stroke={color} strokeWidth="0.5" opacity="0.4" />
  </svg>
);

export const DriedBranch = ({ color = '#a87b5a', className = '' }) => (
  <svg viewBox="0 0 200 40" className={className} aria-hidden="true">
    {/* Rama horizontal */}
    <path d="M10 20 Q100 20 190 20" stroke={color} strokeWidth="0.8" fill="none" opacity="0.5" />
    {/* Hojitas */}
    {[30, 50, 70, 90, 110, 130, 150, 170].map((x, i) => (
      <ellipse
        key={x}
        cx={x}
        cy={i % 2 ? 14 : 26}
        rx="5"
        ry="2.5"
        fill={color}
        opacity="0.4"
        transform={`rotate(${i % 2 ? -30 : 30} ${x} ${i % 2 ? 14 : 26})`}
      />
    ))}
    <circle cx="10" cy="20" r="2" fill={color} opacity="0.6" />
    <circle cx="190" cy="20" r="2" fill={color} opacity="0.6" />
  </svg>
);

export const BohoDivider = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 200 24" className={className} aria-hidden="true">
    <line x1="10" y1="12" x2="80" y2="12" stroke={color} strokeWidth="0.6" opacity="0.5" />
    <line x1="120" y1="12" x2="190" y2="12" stroke={color} strokeWidth="0.6" opacity="0.5" />
    {/* Círculo central con anillo */}
    <circle cx="100" cy="12" r="7" fill="none" stroke={color} strokeWidth="0.8" opacity="0.7" />
    <circle cx="100" cy="12" r="3" fill={color} opacity="0.9" />
    {/* Puntitos laterales */}
    <circle cx="85" cy="12" r="1.5" fill={color} opacity="0.6" />
    <circle cx="115" cy="12" r="1.5" fill={color} opacity="0.6" />
  </svg>
);

export const BohoSun = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 60 60" className={className} aria-hidden="true">
    <circle cx="30" cy="30" r="12" fill="none" stroke={color} strokeWidth="1" opacity="0.7" />
    <circle cx="30" cy="30" r="6" fill={color} opacity="0.4" />
    {[...Array(12)].map((_, i) => {
      const angle = (i * 360) / 12;
      const rad = (angle * Math.PI) / 180;
      return (
        <line
          key={i}
          x1={30 + Math.cos(rad) * 15}
          y1={30 + Math.sin(rad) * 15}
          x2={30 + Math.cos(rad) * 22}
          y2={30 + Math.sin(rad) * 22}
          stroke={color}
          strokeWidth="0.8"
          opacity="0.5"
        />
      );
    })}
  </svg>
);

export const ArrowDown = ({ color = '#c17f59', className = '' }) => (
  <svg viewBox="0 0 30 60" className={className} aria-hidden="true">
    <path d="M15 5 L15 50 M5 40 L15 55 L25 40" stroke={color} strokeWidth="1" fill="none" opacity="0.7" />
  </svg>
);